import React from 'react'
import Typewriter from 'typewriter-effect'
import { getCloudinaryImageUrl } from '../../../../utils'

const textSmallBaseStyle =
  'font-swinton font-normal text-[15px] leading-none tracking-[-0.05em] text-right align-bottom'
const textBodyStyle =
  'text-[25px] leading-[85%] font-extrabold tracking-[-0.05em] text-center font-abcd text-[#1E1E1E] uppercase'
const textBodyStyleSmall =
  'text-[16px] leading-[85%] font-extrabold tracking-[-0.05em] text-center font-abcd text-[#1E1E1E] uppercase'

const Phone = (props: any) => (
  <div className='pt-[105px]'>
    <div className='flex flex-col items-center mb-[50px] pb-0'>
      <div className='flex flex-col items-center w-full'>
        <div className='w-full small-texts w-full bg-white'>
          <div className='flex justify-center'>
            <div className='w-1/3 flex justify-center items-center'>
              <div className={textSmallBaseStyle} data-labelname='headerTextLeft'>
                {props.headerTextLeft}
              </div>
            </div>
            <div className='w-1/3 flex justify-center items-center'>
              <div className={textSmallBaseStyle} data-labelname='headerTextCenter'>
                {props.headerTextCenter}
              </div>
            </div>
            <div className='w-1/3 flex justify-center items-center'>
              <div className={textSmallBaseStyle} data-labelname='headerTextRight'>
                {props.headerTextRight}
              </div>
            </div>
          </div>
        </div>
        {props.headerLargeText && (
          <div
            className={`-mt-[3px] w-4/6 text-center uppercase font-abcd font-extrabold text-[50px] tracking-[-0.05em] leading-[78%]`}
          >
            <Typewriter
              onInit={(typewriter) => {
                typewriter.typeString(props.headerLargeText).start()
              }}
            />
          </div>
        )}
      </div>
    </div>

    {(props.block2Text || props.block2TextBrief) && (
      <div className='flex flex-col items-center mx-2 -mb-[0.20vw]'>
        <div className='px-2'>
          <p className={`${textBodyStyle} mb-5 whitespace-pre-line`} data-labelname='block2Text'>
            {props.block2Text}
          </p>
          <p className={`${textBodyStyleSmall} mb-0`} data-labelname='block2TextBrief'>
            {props.block2TextBrief}
          </p>
        </div>
      </div>
    )}

    {props?.block2Image?.data?.attributes?.url && (
      <div className='w-full relative'>
        <img
          src={getCloudinaryImageUrl(props?.block2Image?.data?.attributes?.url, 'q_auto,dpr_auto,f_auto,w_932')} // Placeholder
          alt=''
          className='w-full'
        />
      </div>
    )}

    {props.block3Text && (
      <div className='flex flex-col items-center mx-auto -mt-[1px] -mb-[1px] px-2'>
        <p className={`${textBodyStyle}`} data-labelname='block3Text'>
          {props.block3Text}
        </p>
      </div>
    )}

    {props?.block3Image?.data?.attributes?.url && (
      <div className='w-full relative'>
        <img
          src={getCloudinaryImageUrl(props?.block3Image?.data?.attributes?.url, 'q_auto,dpr_auto,f_auto,w_932')} // Placeholder
          alt=''
          className='w-full'
        />
      </div>
    )}

    {props.block4Text && (
      <div className='text-center uppercase font-extrabold text-[37px] leading-[78%] tracking-[-0.05em] -mt-[3px] -mb-[2px] font-abcd text-[#1E1E1E] whitespace-pre-line'>
        {props.block4Text}
      </div>
    )}

    {props?.block4Image?.data?.attributes?.url && (
      <div className='w-full relative'>
        <img
          src={getCloudinaryImageUrl(props?.block4Image?.data?.attributes?.url, 'q_auto,dpr_auto,f_auto,w_932')} // Placeholder
          alt=''
          className='w-full'
        />
      </div>
    )}
  </div>
)

export default Phone
